"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _chevronRightSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-right-small"));
var _checkbox = _interopRequireDefault(require("@ingka/checkbox"));
var _radioButton = _interopRequireDefault(require("@ingka/radio-button"));
var _switch = _interopRequireDefault(require("@ingka/switch"));
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _image = _interopRequireDefault(require("@ingka/image"));
var _aspectRatioBox = _interopRequireDefault(require("@ingka/aspect-ratio-box"));
var _paymentLogo = _interopRequireDefault(require("@ingka/payment-logo"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ActionListItem = props => {
  const {
    prefix = '',
    name,
    id,
    control = 'default',
    onClick,
    onChange,
    label,
    caption,
    ssrIcon,
    image,
    imageAltText,
    paymentLogo,
    variant = 'regular',
    inset,
    disabled,
    className,
    controlProps,
    imageProps,
    quantityLabel,
    ...otherProps
  } = props;
  const buttonChild = control === 'default' || control === 'navigational';
  const baseClass = `${prefix}action-list-item`;
  const controlId = id + '__control';
  const classes = (0, _classnames.default)(baseClass, disabled && `${baseClass}--disabled`, className);
  const itemClasses = (0, _classnames.default)(`${baseClass}__action`, inset && `${baseClass}__action--inset`, image && `${baseClass}__action--with-image`);
  const controlTypes = {
    CHECKBOX: 'checkbox',
    RADIOBUTTON: 'radiobutton',
    SWITCH: 'switch',
    NAVIGATIONAL: 'navigational'
  };
  const controlOptsMap = {
    [controlTypes.CHECKBOX]: _react.default.createElement(_checkbox.default, _extends({
      subtle: true,
      id: controlId,
      name: name,
      disabled: disabled,
      onChange: onChange,
      prefix: prefix
    }, controlProps)),
    [controlTypes.RADIOBUTTON]: _react.default.createElement(_radioButton.default, _extends({
      subtle: true,
      id: controlId,
      name: name,
      disabled: disabled,
      onChange: onChange,
      prefix: prefix
    }, controlProps)),
    [controlTypes.SWITCH]: _react.default.createElement(_switch.default, _extends({
      subtle: true,
      id: controlId,
      name: name,
      disabled: disabled,
      onChange: onChange,
      prefix: prefix
    }, controlProps)),
    [controlTypes.NAVIGATIONAL]: _react.default.createElement("span", {
      className: `${baseClass}__chevron`
    }, _react.default.createElement(_ssrIcon.default, {
      prefix: prefix,
      paths: _chevronRightSmall.default
    }))
  };
  const leadingOptsMap = {
    ['image']: _react.default.createElement("span", {
      className: `${baseClass}__image`
    }, _react.default.createElement(_aspectRatioBox.default, {
      prefix: prefix,
      ratio: "square"
    }, _react.default.createElement(_image.default, _extends({
      src: image,
      prefix: prefix,
      alt: imageAltText
    }, imageProps)))),
    ['icon']: _react.default.createElement(_ssrIcon.default, {
      prefix: prefix,
      className: `${baseClass}__icon`,
      paths: ssrIcon
    }),
    ['paymentLogo']: _react.default.createElement(_paymentLogo.default, _extends({
      prefix: prefix,
      className: `${baseClass}__payment-logo`,
      size: variant === 'compact' ? 'small' : 'medium'
    }, paymentLogo))
  };
  const controlType = controlOptsMap[control];
  let leadingMedia = null;
  if (image) {
    leadingMedia = leadingOptsMap.image;
  } else if (paymentLogo && !image) {
    leadingMedia = leadingOptsMap.paymentLogo;
  } else if (ssrIcon && !image && !paymentLogo) {
    leadingMedia = leadingOptsMap.icon;
  }
  const ActionElementTag = buttonChild ? 'button' : 'label';
  return _react.default.createElement("li", _extends({
    id: id,
    className: classes
  }, otherProps), _react.default.createElement(ActionElementTag, {
    htmlFor: control && !buttonChild ? controlId.toString() : null,
    className: itemClasses,
    onClick: !disabled && buttonChild ? onClick : null,
    disabled: buttonChild && disabled
  }, leadingMedia, _react.default.createElement("span", {
    className: `${baseClass}__label-container`
  }, _react.default.createElement("span", {
    className: `${baseClass}__label`
  }, label), caption && _react.default.createElement("span", {
    className: `${baseClass}__caption`
  }, caption)), quantityLabel && (control === 'checkbox' || control === 'radiobutton') && _react.default.createElement("span", {
    className: `${baseClass}__quantity-label`
  }, quantityLabel), controlType));
};
var _default = ActionListItem;
exports.default = _default;